import styled from 'styled-components';
import appTheme from '../../themes/Theme';

export const StyledWrapper = styled.div`
  color: ${appTheme.textColor};
  background-color: ${appTheme.backgroundColor};
  padding-bottom: 32px;
`;

export const StyledWrapChildren = styled.div`
  margin-top: 60px;
  overflow-x: hidden;
`;
